<div class="wrap">
  <div class="header" *ngIf="router.url != '/dashboard'">
    <h1> Camera management</h1>
    <div class="add_camera_and_search_bar">
      <div class="add_camera" (click)="openDialogAddCamera()" (mouseenter)="showElement()" (mouseleave)="show = false"
        *ngIf="isAdmin">
        <fa-icon [icon]="faPlus" class="faPlus"></fa-icon>
        <div class="show_after_hover" *ngIf="show">
          <fa-icon [icon]="faVideo"></fa-icon>
          <span>Add camera</span>
        </div>
      </div>
      <div class="search_bar">
        <input type="text" placeholder="Search a camera ..." (input)="applyFilter($event.target.value)">

        <!-- <fa-icon [icon]=" faTimes" (click)="resetSearch($event)"></fa-icon> -->

        <fa-icon [icon]=" faSearch"></fa-icon>
      </div>
    </div>
  </div>

  <div class="container">


    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" *ngIf="isAdmin">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
        <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
      </ng-container>

      <ng-container matColumnDef="ip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="ip"> Ip </th>
        <td mat-cell *matCellDef="let element"> {{element?.ip}} </td>
      </ng-container>

      <ng-container matColumnDef="port">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="Port"> Port </th>
        <td mat-cell *matCellDef="let element"> {{element?.port}} </td>
      </ng-container>


      <ng-container matColumnDef="syncTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="syncTime"> SyncTime </th>
        <td mat-cell *matCellDef="let element"> {{element?.syncTime}} </td>
      </ng-container>

      <ng-container matColumnDef="numbCars">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> numbCars </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faCar" [routerLink]="['/smartparking/slots']"
            [queryParams]="{name: element?.name, id: element?.id, ip: element?.ip}"
            routerLinkActive="router-link-active">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastSync">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> LastSync </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faInfoCircle" (click)="openDialogInfoCamera(element)"></fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="config">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> Config. </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faCog" (click)="openConfigCamera(element)"></fa-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> Edit </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faPen" [routerLink]="['/smartparking/cameras/update']" routerLinkActive="router-link-active"
            [queryParams]="{name: element.name, id:element.id}"></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsAdmin"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsAdmin"></tr>

    </table>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" *ngIf="!isAdmin">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
        <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
      </ng-container>

      <ng-container matColumnDef="numbCars">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> numbCars </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faCar" [routerLink]="['/smartparking/slots']"
            [queryParams]="{name: element?.name, id: element?.id, ip: element?.ip}"
            routerLinkActive="router-link-active">
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastSync">
        <th mat-header-cell *matHeaderCellDef class="header_infos"> LastSync </th>
        <td mat-cell *matCellDef="let element" class="infos">
          <fa-icon [icon]="faInfoCircle" (click)="openDialogInfoCamera(element)"></fa-icon>
        </td>
      </ng-container>



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
      [color]="color">
    </mat-paginator>



  </div>

</div>
